"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconTrailing = IconTrailing;
var _react = _interopRequireDefault(require("react"));
var _IconContainer = require("./IconContainer.js");
function IconTrailing(_ref) {
  var iconTrailing = _ref.iconTrailing;
  return iconTrailing ? /*#__PURE__*/_react["default"].createElement(_IconContainer.IconContainer, {
    $position: "trailing"
  }, iconTrailing) : null;
}